import $ from 'jquery';

export default () => {
  $.fn.transition = require('semantic-ui-transition');
  $.fn.dimmer = require('semantic-ui-dimmer');
  $.fn.modal = require('semantic-ui-modal');
  $.fn.checkbox = require('semantic-ui-checkbox');
  $.fn.dropdown = require('semantic-ui-dropdown');
  $.fn.popup = require('semantic-ui-popup');

  // Enabling dropdowns app wide
  $('.ui.dropdown').dropdown();
};



// WEBPACK FOOTER //
// ./src/semantic.js